<template>
    <v-card-title>
        <v-container class="pa-12">
            <v-card class="pl-16 pr-16 pt-8 pb-16">
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="6" justify="center">
                            <h3>New Document</h3>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-row class="row1 mt-3  pt-3 ">
                    <v-col cols="12" md="7">
                        <v-text-field outlined dense label="Document Type" background-color="#F5F5F5"
                            disabled></v-text-field>
                    </v-col>
                </v-row>

                <br />

                <template>
                    <template>
                        <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1 ">
                            <template v-slot:item.type="{ item }">
                                <div v-if="item.type == 'Dropdown'">
                                    <v-expansion-panels v-model="item.ShowDrop" accordion class="mb-2 mt-2">
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>{{ item.type }}</v-expansion-panel-header>
                                            <v-expansion-panel-content class="mt-1">
                                                <v-row class="ml-2" v-if="item.datadropdown.length > 0"
                                                    v-for="(data, index) in item.datadropdown" :key="index">
                                                    <v-row>
                                                        <v-col cols="12" sm="10" class="mt-2 mb-2">
                                                            {{ index + 1 }}. {{ item.datadropdown[index].text }}
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </div>
                                <div v-else="">
                                    <v-row class="mt-2 mb-2 ml-3">
                                        <v-col cols="12" sm="12">
                                            {{ item.type }}
                                        </v-col>
                                    </v-row>

                                </div>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn class="mr-2" @click="deleteItem(item)" :style="{
                                    backgroundColor: '#254E58',
                                    color: 'white',
                                }">
                                    <v-icon small>
                                        save
                                    </v-icon>
                                </v-btn>
                                <v-btn @click="deleteItem(item)" :style="{
                                    backgroundColor: '#9E3B1B',
                                    color: 'white',
                                }">
                                    <v-icon small>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </template>

                    <div v-if="showAdd" class="pl-2 pr-2 pt-6 pb-1 elevation-1">
                        <template>
                            <v-row>
                                <v-col cols="12" md="4" class="ml-1">
                                    <v-text-field dense outlined label="Title"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-autocomplete :items="type_list" label="Type" dense outlined
                                        @change="showTypeDropdown()" v-model="documnet_type"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="1">
                                    <v-btn class="ml-2" :style="{
                                        backgroundColor: '#254E58',
                                        color: 'white',
                                    }"> <span>Save</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="showdropdown" class="ml-1" v-for="(item, index) in dropdownlist" :key="index">
                                <v-row>
                                    <v-col cols="12" md="5" offset="4">
                                        <v-text-field v-model="dropdownlist[index].text" dense outlined
                                            label="Drowdown item"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="1">
                                        <v-btn v-if="index == 0" :style="{
                                            backgroundColor: '#a7c4ae',
                                            color: 'green',
                                        }" icon>
                                            <v-icon @click="inputapprover">mdi-plus</v-icon>
                                        </v-btn>
                                        <v-btn v-else="" :style="{
                                            backgroundColor: '#FFEBEE',
                                            color: '#F44336',
                                        }" icon @click="deletedropdown(index)">
                                            <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                            </v-row>
                        </template>
                    </div>
                </template>
                <br />
                <div>
                    <v-row class="mt-2">
                        <v-col cols="12" md="12">
                            <v-span>
                                <h5>Setup Department Authorization</h5>
                            </v-span>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col cols="12" md="10">
                            <v-select v-model="authori_depart" outlined dense ref="myDep" :items="depart_list"
                                item-text="department_name" item-value="id" multiple disabled></v-select>
                        </v-col>
                    </v-row>
                </div>
                <br />
                <br />
                <div>
                    <v-row>
                        <v-col align="center" cols="12" md="12">
                            <v-btn depressed outlined width="100" to="/document-setup">
                                Cance
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>

            <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

            <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
                :link="link" />
        </v-container>
    </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
    tolocalestringnumber,
    stringcommatonumber,
} from "./computing/tolocalestringnumber";

export default {
    name: "NewAdvance",
    data() {
        return {
            authori_depart: [],
            depart_list: [],
            type_list: ["Dropdown", "Text", "Date"],
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            documnet_type: "",
            showdropdown: false,
            showdropdownDataTable: false,
            showAdd: false,
            seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
            desserts: [],
            dropdownlist: [
                {
                    doctemplate_id: 0,
                    text: ""
                }
            ],
            dropdownlistTable: [],
            headers: [
                {
                    text: "Title",
                    value: "title",
                    class: "bg-colorth",
                    align: "start",
                    divider: true,
                    sortable: false,
                    width: "25%",
                },
                {
                    text: "Type",
                    align: "start",
                    value: "type",
                    class: "bg-colorth",
                    align: "start",
                    divider: true,
                    sortable: false,
                    width: "50%",
                },
            ]
        };
    },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
    },
    watch: {
    },
    async mounted() {
        const userId = localStorage.getItem(server.USER_ID);
        if (userId && api.isLoggedIn()) {
            // this.$router.push("/");
        } else {
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        }
        if (this.$route.params.mode == "Add") {
            this.showAdd = true;
        }
        await this.loadDepartment();
        await this.loadDoctype();
        await this.loadDoctypeTemplate();
        this.$hideLoader();
    },
    methods: {
        async loadDepartment() {
            const res_depart = await api.getNewAllDepartment_By_CompanyID(localStorage.getItem(server.COMPANYID));
            console.log(res_depart.data)
            this.depart_list = res_depart.data;
        },
        async loadDoctype() {
            const res_doctype = await api.getDoctypeByID(this.$route.params.doctype_id)
            this.doctype = res_doctype.data[0].doctype;
            if (res_doctype.data[0].department_authorization != "") {
                const dep_au = res_doctype.data[0].department_authorization
                const temp_dep = dep_au.split(',');
                for (let i = 0; i < temp_dep.length; i++) {
                    temp_dep[i] = Number(temp_dep[i])
                }
                // console.log(temp_dep)
                this.authori_depart = temp_dep;

            }
        },
        async loadDoctypeTemplate() {
            const res_doctypetemplate = await api.getDoctypeTemplateByID(this.$route.params.doctype_id)
            this.desserts = res_doctypetemplate.data;
            this.desserts.forEach(async (item) => {
                if (item.type == "Dropdown") {
                    const res_docdrop = await api.getDocDropByDoctempID(item.id)
                    item.datadropdown = res_docdrop.data;
                } else {
                    item.datadropdown = [];
                }
                item.textdrop = "";
            })
            console.log(this.desserts)

        },
        saveItem() {

        },
        showTypeDropdown() {
            // alert(this.documnet_type)
            if (this.documnet_type == "Dropdown") {
                this.showdropdown = true;
            } else {
                this.showdropdown = false;
                this.dropdownlist = [{
                    doctemplate_id: 0,
                    text: ""
                }]
            }
        },
        async inputapprover() {
            this.dropdownlist.push({
                doctemplate_id: 0,
                text: ""
            });
        },
        async deletedropdown(index) {
            this.dropdownlist.splice(index, 1);
        },
        async inputapproverTable() {
            this.dropdownlistTable.push({
                doctemplate_id: 0,
                text: ""
            });

        },
        async deletedropdownTable(index) {
            this.dropdownlistTable.splice(index, 1);
        },
        showsearchmore() {
            this.toggleEnable = !this.toggleEnable;
            this.seticonsearchmore.action = !this.seticonsearchmore.action;
            if (this.seticonsearchmore.action === true) {
                this.seticonsearchmore.icon = "mdi mdi-chevron-up";
                this.showdropdownDataTable = true;
            } else {
                this.seticonsearchmore.icon = "mdi mdi-chevron-down";
                this.showdropdownDataTable = false;
            }
        },
    },
    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
};
</script>
<style scoped>
.v-btn:not(.v-btn--round).v-size--default.buttonred {
    background-color: #9e3b1b;
    color: white;
}

.test_show {
    font-size: 17px;
}
</style>